/**
 * Thẻ khách hàng được quản lý — thông tin công khai và khu vực dữ liệu riêng tư.
 */
import { formatBudgetRange } from '../../shared/utils/formatBudgetRange';

const PrivateDetail = ({ label, value, fallback }) => (
  <div className="admin-user-private-item">
    <span>{label}</span>
    <strong>{value || fallback}</strong>
  </div>
);

export const AdminManagedUserCard = ({
  managedUser,
  labels,
  common,
  isSelected,
  onSelect,
}) => (
  <article className={`admin-user-card admin-managed-user-card ${isSelected ? 'is-selected' : ''}`.trim()}>
    <button type="button" className="admin-managed-user-select" onClick={() => onSelect(managedUser.id)}>
      <div className="admin-user-card-header">
        <div className="admin-user-card-profile">
          {managedUser.avatar ? (
            <img className="admin-user-card-avatar" src={managedUser.avatar} alt="" loading="lazy" />
          ) : (
            <span className="admin-user-card-avatar admin-user-card-avatar--fallback" aria-hidden="true">
              {managedUser.name?.charAt(0)?.toUpperCase() || 'U'}
            </span>
          )}
          <div>
            <h2>{managedUser.name}</h2>
            <span className="admin-user-role-badge admin-user-role-badge--customer">{labels.roleLabel}</span>
          </div>
        </div>
      </div>

      <div className="admin-user-card-meta">
        <span className="admin-user-meta-item">{managedUser.email}</span>
        <span className="admin-user-meta-item">{managedUser.phone || common.noPhone}</span>
        <span className="admin-user-meta-item admin-user-meta-item--wide">
          {labels.preferredProvince}: {managedUser.preferred_province || common.notUpdated}
        </span>
        <span className="admin-user-meta-item admin-user-meta-item--wide">
          {labels.budgetRange}: {formatBudgetRange(managedUser.budget_min, managedUser.budget_max, {
            notProvided: common.notUpdated,
            budgetFrom: common.budgetFrom,
            budgetUpTo: common.budgetUpTo,
          })}
        </span>
      </div>

      <div className="admin-user-private-section">
        <div className="admin-user-private-head">
          <strong>{labels.privateSectionTitle}</strong>
        </div>
        <div className="admin-user-private-grid">
          <PrivateDetail
            label={labels.residentialAddress}
            value={managedUser.residential_address}
            fallback={common.notUpdated}
          />
          <PrivateDetail label={labels.hometown} value={managedUser.hometown} fallback={common.notUpdated} />
          <PrivateDetail label={labels.residence} value={managedUser.residence} fallback={common.notUpdated} />
          <PrivateDetail
            label={labels.age}
            value={managedUser.age ? String(managedUser.age) : ''}
            fallback={common.notUpdated}
          />
          <PrivateDetail label={labels.cccd} value={managedUser.cccd} fallback={common.notUpdated} />
        </div>
      </div>
    </button>
  </article>
);
